import { useData } from "../../hooks/useData";
import { Reveal } from "../ui-custom/Reveal";

// Editorial About with numbered manifesto chapters.
export default function AboutStory() {
  const { data } = useData("about");
  if (!data) return null;

  return (
    <div className="grid gap-14 lg:grid-cols-2 lg:items-start">
      <div className="lg:sticky lg:top-28">
        <Reveal className="relative overflow-hidden rounded-[2rem] grad-border">
          <img src={data.image} alt="UtiPanagency" loading="lazy" className="h-full w-full object-cover" />
          <div className="absolute bottom-0 grid w-full grid-cols-3 gap-2 p-6">
            {data.stats.map((s) => (
              <div key={s.label} className="rounded-xl glass-strong p-3 text-center">
                <p className="text-lg font-bold text-gradient">{s.value}</p>
                <p className="text-[11px] text-slate-500">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      <div>
        <Reveal>
          <p className="max-w-lg text-lg leading-relaxed text-slate-600">{data.story}</p>
        </Reveal>
        <div className="mt-10 space-y-8">
          {data.chapters.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.08} className="flex gap-5 border-t border-slate-200 pt-6" data-testid={`about-chapter-${i}`}>
              <span className="text-2xl font-bold text-gradient font-display">{c.no}</span>
              <div>
                <h4 className="text-lg font-semibold text-slate-900">{c.title}</h4>
                <p className="mt-1.5 text-sm text-slate-500">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-10 rounded-2xl bg-brand-soft p-6">
          <p className="text-xs uppercase tracking-widest text-brand-2">Our Mission</p>
          <p className="mt-2 text-lg font-medium text-slate-900">{data.mission}</p>
        </Reveal>
      </div>
    </div>
  );
}
